$(document).ready(function () {
    $(document).on("submit", "form.RetOrderForm", function () {
        $form = $(this);

        $.ajax({
            type: "POST",
            url: $form.attr("action"),
            data: $form.serialize(),
            dataType: "json",
            beforeSend: function () {
                GenerateLocalLoading($form, "show");
            },
            success: function (dt) {
                if (dt.Sonuc === true) {

                    $form.hide();

                    $("#RetOrderResult").show().html(dt.IslemSonucAciklama);
                    $(".RetTypeHome").css("display", "inline-block");
                }
                else {
                    SwalGenerate("error", dt.IslemSonucAciklama, getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
                }

                $('html, body').animate({
                    scrollTop: 0
                }, 500);

            },
            error: function () {
                SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("IslemBasarisiz"), getStandartMessages("Kapat"));
            },
            complete: function () {
                GenerateLocalLoading($form, "hide");
            }
        });

        return false;
    });

    $(document).on("change", ".CancelRow select.RetType", function () {
        var CurrencyCode = $("#CurrencyCode").val();
        var CName = $("#CName").val();

        if (CName == "Home") {
            url = getRequestRoute() + "/p/Home/RetOrderType";
        } else {
            url = getRequestRoute() + "/p/Orders/RetOrderType";
        }

        var value = $(this).val();
        var item = $(this);
        var returnProduct = item.closest(".CancelRow").hasClass("returnProduct");

        if (value == "0") {
            item.closest(".CancelRow").find(".RetReason").css("display", "none");
        }

        else if (value == "1" || value == "2") {
            $.ajax({
                type: "POST",
                url: url,
                data: "RetType=" + value,
                dataType: 'json',
                success: function (dta) {
                    dta.JsonRs = JSON.parse(dta.JsonRs);
                    item.closest(".CancelRow").find(".RetReason").html("");

                    for (var i = 0; i < dta.JsonRs.length; i++) {
                        item.closest(".CancelRow").find(".RetReason").append(new Option(dta.JsonRs[i].Text, dta.JsonRs[i].Value));
                    }

                    item.closest(".CancelRow").find(".RetReason").css("display", "block");

                },
                error: function () {
                    SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("IslemBasarisiz"), getStandartMessages("Kapat"));
                }
            });
        }
        else if (value == "-1") {
            item.closest(".CancelRow").find(".RetReason").css("display", "none");
        }

        var slc = $(this);
        var oid = slc.attr("dataid");
        var ind = slc.attr("dataind");
        var kacitem = parseInt($(".CancelRow select.RetType").length);
        if (kacitem <= 0) return;
        var itemsay = 0;

        var iaTutar = parseFloat(calcIadeTutari());
        var siptutar = parseFloat($("#TotalRetOrderAmount").attr("dataAmount").replace(",", "."));

        if (value === "2" || value === "4") {
            itemsay = parseInt(itemsay) + 1;
            //iaTutar += parseFloat($('#urunAmount' + $(this).attr("dataid")).val().replace(",", "."));
            item.closest(".CancelRow").addClass("returnProduct");
        }
        else if (iaTutar > 0 && returnProduct == true) {
            //iaTutar -= parseFloat($('#urunAmount' + $(this).attr("dataid")).val().replace(",", "."));
            item.closest(".CancelRow").removeClass("returnProduct");
        }

        //if (kacitem === itemsay) {
        //    iaTutar = siptutar;
        //}
        if (itemsay > 0 && iaTutar > 0) {
            //$(".iadedivi").removeClass("d-none");
        }
        else if (itemsay == 0 && iaTutar == 0) {
            $(".iadedivi").addClass("d-none");
        }
        if (slc.val() === "1") { //değişim yapmak istiyorum
            //$(".CancelRow select[name=\"RetItem[" + ind + "].DegisimStoklar\"]").removeClass("d-none");
            $(".CancelRow textarea[name=\"RetItem[" + ind + "].DegisimMessage\"]").css("display", "block");
        }
        else {
            $(".CancelRow select[name=\"RetItem[" + ind + "].DegisimStoklar\"]").addClass("d-none");
            $(".CancelRow textarea[name=\"RetItem[" + ind + "].DegisimMessage\"]").css("display", "none");
        }

        $("#RetTotalAmount").html((iaTutar).toFixed(2) + " " + CurrencyCode);
        $("#RetTotalAmountVal").val(iaTutar);
        $("#OrderAmountAfterRet").html((siptutar - iaTutar).toFixed(2) + " " + CurrencyCode);
    });

    function calcIadeTutari() {
        var totalRetVal = 0;

        $(".CancelItems .RetOrderItem.CancelRow").each(function () {
            var retTypeVal = $(this).find("select.RetType").val();

            if (retTypeVal == 2 || retTypeVal == 6) {
                totalRetVal += $(this).find("input[type='hidden']").first().val();
            }
        });

        return totalRetVal;
    }

    // Sipariş iade sayfası yazdırma işleminden sonra iade talebi gönderme butonu tetikletilmesi
    // return sonuc sayfası döndürdüğünden kapatıldı
    //var sendPrintReturn = document.getElementsByClassName("ReturnPrintButton");

    //if (sendPrintReturn.length > 0) {
    //    $(sendPrintReturn).click(function () {
    //        if (confirm("İade talebini göndermek istediğinize emin misiniz?") == true) {
    //            window.print();

    //            window.onafterprint = function () {
    //                $(".AcceptReturnBtn").trigger("click");
    //            }
    //        }
    //    });
    //}
});

//function maxLengthCheck(object) {
//    if (object.value.length > object.maxLength)
//        object.value = object.value.slice(0, object.maxLength)
//}

//function isNumeric(evt) {
//    var theEvent = evt || window.event;
//    var key = theEvent.keyCode || theEvent.which;
//    key = String.fromCharCode(key);
//    var regex = /[0-9]|\./;
//    if (!regex.test(key)) {
//        theEvent.returnValue = false;
//        if (theEvent.preventDefault) theEvent.preventDefault();
//    }
//}
